module.exports = __webpack_public_path__ + "img/tab-status.eac8a907.png";